<!--
 * @Auther: 罗耀祖
 * @Date: 2022-02-23 16:45:30
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-11 14:48:44
 * @name: 审批-售后经理(run_act=xuyingxiaozhuren)
 * @Description: 售后经理审批,选择是否需要营销主任审批
 * @FilePath: \project\src\components\afterSale\dialog-approve-xuyingxiaozhuren.vue
 * @Author: desktop
-->
<template>
  <el-dialog title="审批处理" width="650px" :visible.sync="show" @close="close">
    <div class="content">
      <div class="row">
        <font class="label">审批结果</font>
        <font class="text">审批通过</font>
      </div>
      <div class="row">
        <font class="label">是否需要营销中心主任审批：</font>
        <el-radio-group size="mini" v-model="sale_manager_check_status">
          <el-radio :label="0">否</el-radio>
          <el-radio :label="1">是</el-radio>
        </el-radio-group>
      </div>
      <div class="row">
        <font class="label">审批建议</font>
        <el-input
          class="remark"
          type="textarea"
          :rows="2"
          :placeholder="'请输入审批建议...'"
          v-model="remark"
        >
        </el-input>
      </div>
      <div class="btn-group">
        <el-button size="mini" @click="show = false">取消</el-button>
        <el-button size="mini" type="primary" @click="confirm">提交</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
import issueService from "@/module/issue/issue.service";
import { debounceation } from "@/utils/decorator";
export default {
  data() {
    return {
      issueService: new issueService(),
      show: false,
      issue_id: "",
      run_process_id: "",
      type: "",
      value: "",
      sale_manager_check_status: 0,
      remark: "",
    };
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 打开弹窗
     * @param {Object} item 传递数据
     */
    open(param) {
      this.issue_id = param.issue_id;
      this.run_process_id = param.run_process_id;
      this.type = param.type;
      this.value = param.value;
      this.show = true;
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 弹窗关闭回调
     */
    close() {
      this.type = "";
      this.value = "";
      this.remark = "";
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 点击提交
     */
    @debounceation(300)
    confirm() {
      let params = {
        issue_id: this.issue_id,
        run_process_id: this.run_process_id,
        act: this.value,
        sale_manager_check_status: this.sale_manager_check_status,
        remark: this.remark,
      };
      this.issueService.saleServiceManagerVerify(params).then((res) => {
        this.$emit("finish");
        this.show = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  width: 100%;
  @extend .et-flex-column-normal;
  .row {
    width: 100%;
    margin-bottom: 18px;
    @extend .et-flex-normal;
    font-size: $Vars-font-content-size;
    .label {
      color: $Vars-font-important-color;
      font-weight: bold;
      margin-right: 10px;
    }
    .text {
      color: $Vars-font-normal-color;
    }
    .remark {
      flex: 1;
    }
  }
  .btn-group {
    width: 100%;
    @extend .et-flex-center;
  }
}
</style>